import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const MobileMenu = ({ items, open, onNavigate }) => {
  const location = useLocation();
  const onHome = location.pathname === '/';

  const renderItem = (n) => {
    const linkClass =
      'text-sm tracking-[0.2em] uppercase text-[#1a1a1a] hover:text-[#7B1E24]';
    if (n.route) {
      return (
        <Link key={n.href} to={n.href} onClick={onNavigate} className={linkClass}>
          {n.label}
        </Link>
      );
    }
    const href = onHome ? n.href : `/${n.href}`;
    return (
      <a key={n.href} href={href} onClick={onNavigate} className={linkClass}>
        {n.label}
      </a>
    );
  };

  return (
    <div
      className={`lg:hidden overflow-hidden transition-all duration-500 bg-[#FAF7F2] border-t border-[#E5DED0] ${
        open ? 'max-h-[640px]' : 'max-h-0'
      }`}
    >
      <div className="px-6 py-6 flex flex-col gap-4">
        {items.map(renderItem)}
        {onHome ? (
          <a
            href="#contact"
            onClick={onNavigate}
            className="btn-cherry text-center px-5 py-3 rounded-full text-xs tracking-[0.2em] uppercase mt-2"
          >
            Get a Quote
          </a>
        ) : (
          <Link
            to="/#contact"
            onClick={onNavigate}
            className="btn-cherry text-center px-5 py-3 rounded-full text-xs tracking-[0.2em] uppercase mt-2"
          >
            Get a Quote
          </Link>
        )}
      </div>
    </div>
  );
};

export default MobileMenu;
